/** @format */

import React, { Component } from 'react';
import { Form, Menu } from 'semantic-ui-react';
import { observer, inject } from 'mobx-react';
import { getUnixDateFromTimestamp } from '../../../helpers/getUnixDateFromTimestamp';

@inject('SalesStore')
@observer
class DeepSearch extends Component {
  render() {
    let { SalesStore } = this.props;
    let deepSearch = SalesStore.salesParams.advancedSearch.active;
    let dateRangeStart = SalesStore.salesParams.advancedSearch.dateRange.start;
    let dateRangeEnd = SalesStore.salesParams.advancedSearch.dateRange.end;
    return (
      <div
        className={
          deepSearch ? 'advance-search-wrapper open' : 'advance-search-wrapper'
        }
      >
        <Form>
          <Menu className="advance-toolbar" borderless size="small">
            <Menu.Menu position="left">
              <Menu.Item>
                <Form.Input
                  inline
                  value={getUnixDateFromTimestamp(dateRangeEnd)}
                  onChange={e => {
                    let date = e.target.value + ' 00:00:00';
                    SalesStore.timeIntervalInput(date, e.target.name);
                  }}
                  size="mini"
                  name="end"
                  label="Dal"
                  type="date"
                ></Form.Input>
              </Menu.Item>
              <Menu.Item>
                <Form.Input
                  inline
                  onChange={e => {
                    let date = e.target.value + ' 00:00:00';
                    SalesStore.timeIntervalInput(date, e.target.name);
                  }}
                  value={getUnixDateFromTimestamp(dateRangeStart)}
                  size="mini"
                  name="start"
                  label="Al"
                  type="date"
                ></Form.Input>
              </Menu.Item>
            </Menu.Menu>
            <Menu.Menu position="right">
              <Menu.Item>
                <Form.Input
                  inline
                  onChange={e =>
                    SalesStore.priceRangeInput(e.target.value, e.target.name)
                  }
                  value={SalesStore.salesParams.advancedSearch.priceRange.min}
                  max={SalesStore.salesParams.advancedSearch.priceRange.max}
                  size="mini"
                  name="min"
                  label="Da €"
                  type="number"
                ></Form.Input>
              </Menu.Item>
              <Menu.Item>
                <Form.Input
                  inline
                  onChange={e =>
                    SalesStore.priceRangeInput(e.target.value, e.target.name)
                  }
                  value={SalesStore.salesParams.advancedSearch.priceRange.max}
                  min={SalesStore.salesParams.advancedSearch.priceRange.min}
                  size="mini"
                  name="max"
                  label="A €"
                  type="number"
                ></Form.Input>
              </Menu.Item>
              {/* <Menu.Item>
                                <Form.Button
                                    size="mini"
                                    color="green"
                                    type="submit"
                                    ><Icon name="search"/>Cerca
                                </Form.Button>
                            </Menu.Item> */}
            </Menu.Menu>
          </Menu>
        </Form>
      </div>
    );
  }
}

export default DeepSearch;
